import Ticket from '../pages/request/ticket'
export default Ticket
